import { BankTransfer } from '@/models'
import { AcompteListItem } from '../types/acompteList'

function formatDate(value?: string | Date | null): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  return date.toLocaleDateString('fr-FR')
}

export function mapAcompteToListItem(bankTransfer: BankTransfer): AcompteListItem {
  return {
    id: bankTransfer.id || '',
    amount: bankTransfer.amount,
    status: bankTransfer.pending ? 'pending' : 'validated',
    orderReference: bankTransfer.orderReference || null,
    reserved: bankTransfer.orderReference?.startsWith('CMD-') || false,
    comment: bankTransfer.comment || null,
    date: formatDate(bankTransfer.createdAt),
    createdAt: bankTransfer.createdAt ? String(bankTransfer.createdAt) : ''
  }
}
